import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    primary: {
      main: '#0d2e4c',
    },
    secondary: {
      main: '#2a3aff',
    },
    secondaryBackground: {
      main: '#000e1c',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#000',
      secondary: '#000',
    },
    sidebar: {
      main: '#B2C4FA',
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input.Mui-disabled': {
            color: 'black',
            backgroundColor: '#f1f1f1',
            '-webkit-text-fill-color': 'black',
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: '#7b8295',
            '-webkit-text-fill-color': '#7b8295',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiFormLabel-root.Mui-disabled': {
            color: '#7b8295',
            '-webkit-text-fill-color': '#7b8295',
          },
          '& .MuiInputBase-root.Mui-disabled': {
            color: '#7b8295',
            backgroundColor: '#f1f1f1',
            '-webkit-text-fill-color': '#7b8295',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input.Mui-disabled': {
            color: 'black',
            backgroundColor: '#f1f1f1',
            '-webkit-text-fill-color': 'black',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: '#2a3aff',
            color: '#ffffff',
          },
        },
        {
          props: { variant: 'outlined' },
          style: {},
        },
      ],
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '16px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          marginBottom: '20px',
          backgroundColor: '#fff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          //border: '1px solid #E9EBFF',
        },
        head: {
          fontSize: '1rem',
          fontWeight: 'bold',
          //color: '#2a3aff',
          //backgroundColor: '#f5f5f5',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, .16)',
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexWrap: 'wrap',
          marginTop: '-24px',
          '@media (max-width: 600px)': {
            flexDirection: 'row',
            gap: '4px',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          overflowY: 'auto',
        },
      },
    },
    MuiChip: {
      variants: [
        {
          props: { label: 'active' },
          style: {
            backgroundColor: '#4caf50',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'canceled' },
          style: {
            backgroundColor: '#f44336',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'incomplete' },
          style: {
            backgroundColor: '#ff9800',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'incomplete_expired' },
          style: {
            backgroundColor: '#9e9e9e',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'past_due' },
          style: {
            backgroundColor: '#ff5722',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'trialing' },
          style: {
            backgroundColor: '#2196f3',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'unpaid' },
          style: {
            backgroundColor: '#795548',
            color: '#ffffff',
          },
        },
        {
          props: { label: 'paused' },
          style: {
            backgroundColor: '#673ab7',
            color: '#ffffff',
          },
        },
      ],
    },

    MuiTypography: {
      styleOverrides: {
        h6: {
          fontWeight: 'bold',
        },
        h7: {
          fontWeight: 'bold',
        },
        subtitle2: {
          color: 'gray',
        },
        title: {
          fontSize: '1rem',
        },
        label: {
          fontWeight: 'bold',
        },
        date: {
          textDecoration: 'underline',
        },
      },
    },
  },
});

export default lightTheme;
